export default __webpack_public_path__ + "static/earth-7b4045e068fac4084e4b71d850512d57.png";